import React, { useState } from "react"
import { FormattedMessage } from "react-intl"
import NewCreditMemoModal from "../../../../invoice/credit-memo/NewCreditMemoModal"
import Icon from "../../../icon/icon.component.jsx"

interface OwnProps {
    onCloseCallback: () => void
}


const CreditMemoCreationButton = (props: OwnProps) => {

    const [openModal, setOpenModal] = useState<boolean>(false)

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
        props.onCloseCallback()
    }

    return (
        <>
            {openModal && (
                <NewCreditMemoModal
                    canSelectContact={true}
                    onClose={handleCloseModal}
                />
            )}
            <button onClick={handleOpenModal} className="btn btn-primary">
                <Icon value="file-invoice-dollar" />
                <FormattedMessage
                    id="generic-listing.credit-memos.create-btn-text"
                    defaultMessage="New credit memo"
                />
            </button>
        </>
    )
}

export default CreditMemoCreationButton


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/creation-buttons/CreditMemoCreationButton.tsx